var React = require('react');

function MenuExpand (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2.11548 8H26.0546","stroke":"#7200A0","strokeWidth":"3","strokeLinecap":"round","key":0}),React.createElement("path",{"d":"M10.0952 14L21.0672 14","stroke":"#7200A0","strokeWidth":"3","strokeLinecap":"round","key":1}),React.createElement("path",{"d":"M6.10535 2L17.0774 2","stroke":"#7200A0","strokeWidth":"3","strokeLinecap":"round","key":2})]);
}

MenuExpand.defaultProps = {"width":"28","height":"16","viewBox":"0 0 28 16","fill":"none"};

module.exports = MenuExpand;

MenuExpand.default = MenuExpand;
